import React from 'react';
import { string, bool, func, number } from 'prop-types';
import { DeliveryOptions } from '@thd-olt-component-react/delivery-options';
import { TileHead } from '../TileHead';
import { TileFooter } from '../TileFooter';

const OffshoreSthUnavailable = ({
  itemId,
  quantity,
  stateName
}) => {

  return (
    <>
      <div className="u__center">
        <TileHead
          title="Ship to Home"
          icon="pick-up-false"
        />
        <div className="warning_text">Not available in {stateName}</div>
      </div>
      <TileFooter>
        <DeliveryOptions
          itemId={itemId}
          quantity={quantity}
        >
          Change Zip
        </DeliveryOptions>
      </TileFooter>
    </>
  );
};
OffshoreSthUnavailable.propTypes = {
  itemId: string.isRequired,
  quantity: number,
  stateName: string
};
OffshoreSthUnavailable.defaultProps = {
  stateName: null,
  quantity: 1
};

export { OffshoreSthUnavailable };
